import { render, staticRenderFns } from "./LoaderUI2.vue?vue&type=template&id=6dab68ec&scoped=true&"
import script from "./LoaderUI2.vue?vue&type=script&lang=js&"
export * from "./LoaderUI2.vue?vue&type=script&lang=js&"
import style0 from "./LoaderUI2.vue?vue&type=style&index=0&id=6dab68ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dab68ec",
  null
  
)

export default component.exports